var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNomeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16064 3.161L1.74731 4.57433L5.0159 7.84292C3.60945 9.21557 2.60605 10.9993 2.19994 13C2.06877 13.6462 1.99991 14.3151 1.99991 15H12.173L13.173 16H1.99991V18H4.58569L5.29279 18.7071C5.48033 18.8946 5.73468 19 5.9999 19H16.173L19.425 22.252L20.8383 20.8387L3.16064 3.161ZM4.25194 13C4.6242 11.5536 5.39078 10.2656 6.43024 9.25726L10.173 13H4.25194Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.828 18H21.9999V16H18.8281L20.828 18Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8281 15H21.9999C21.9999 14.3151 21.931 13.6462 21.7998 13C21.0038 9.07851 17.9131 5.99032 13.9902 5.19808C13.9966 5.13292 13.9999 5.06684 13.9999 5C13.9999 3.89543 13.1045 3 11.9999 3C10.8953 3 9.9999 3.89543 9.9999 5C9.9999 5.06684 10.0032 5.13292 10.0096 5.19808C9.47974 5.30508 8.96508 5.45397 8.4692 5.64114L10.0639 7.23584C10.6838 7.08177 11.3323 7 11.9999 7C15.7276 7 18.8598 9.54955 19.7478 13H15.8281L17.8281 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNomeal);
export default __webpack_public_path__ + "static/media/nomeal.0dfb302c6f1bd636226dab97b6d38162.svg";
export { ForwardRef as ReactComponent };